export const Loader = () => {
  return (
    <div className="loader-wrap">
      <span className="loader"></span>
    </div >
  );
};
